import * as buttonVariants from '../Button/variants';

export const size = {
  xs: {
    gap: '$1',
    px: '$2',
    fontSize: '$xs',
    fontWeight: '$normal',
    height: '$5',
    borderRadius: '$full',
  },
  sm: {
    gap: '$2',
    px: '$3',
    fontSize: '$sm',
    fontWeight: '$normal',
    height: '$6',
    borderRadius: '$full',
  },
  md: {
    gap: '$2',
    px: '$3',
    fontSize: '$base',
    fontWeight: '$normal',
    height: '$8',
    borderRadius: '$full',
  },
};

export const intents = buttonVariants.intents;
